import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, FNOFFICER_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchApproved = (approved: any) => ({
    type: 'FETCH_APPROVED_SUCCESS',
    payload: approved,
});
export const fetchApplied = (applied: any) => ({
    type: 'FETCH_APPLIED_SUCCESS',
    payload: applied,
});
export const fetchNotpaid = (notpaid: any) => ({
    type: 'FETCH_NOTPAID_SUCCESS',
    payload: notpaid,
});
export const fetchAllApplied = (allapplications: any) => ({
    type: 'FETCH_ALL_SUCCESS',
    payload: allapplications,
});



export const fetchApprovedData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,userid:uid};
            const apiname = FNOFFICER_API.fapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApproved(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAppliedData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,userid:uid};
            const apiname = FNOFFICER_API.fapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApplied(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const NotpaidApplicationData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,userid:uid};
            const apiname = FNOFFICER_API.fapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApplied(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAllApplicationdData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,userid:uid};
            const apiname = FNOFFICER_API.fapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAllApplied(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

